var exports = {
  "k": "x9997bc76--1007c0--container",
};

module.exports = exports;
